import axiosInstance from '../axiosInstance';


/**
 * @name upload
 * @desc Upload material.
 * @param {formData} formData
 */
export const upload = formData => {
    const config = {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    };
    return axiosInstance.post('materials', formData, config);
};


/**
 * @name getMaterial
 * @desc Get single material by materialID.
 * @param {string} materialID
 * @return object
 */
export const getMaterial = materialID => {
    return axiosInstance.get(`materials/${materialID}`);
}


/**
 * @name getEventsPartnersFiles
 * @desc Get partner's files related to an event.
 * @param {string} eventID
 * @param {string} partnerID
 */
export const getPartnersEventFiles = (eventID, partnerID) => {
    const url = `events/${eventID}/partners/${partnerID}/files`;
    return axiosInstance.get(url);
}


/**
 * @name deletePartnersEventFile
 * @desc Delete single file of a partner.
 * @param {string} partnerID
 * @param {int} fileID
 */
export const deletePartnersEventFile = (partnerID, fileID) => {
    const url = `partners/${partnerID}/eventsPartnersFiles/${fileID}/delete`;
    return axiosInstance.get(url);
}


/**
 * @name uploadPartnersEventFile
 * @desc Link material to partner's event files.
 * @param {string} eventID
 * @param {string} partnerID
 * @param {object} data
 */
export const uploadPartnersEventFile = (eventID, partnerID, data) => {
    const partnersEventFileUrl =  `events/${eventID}/partners/${partnerID}/files`;
    return axiosInstance.post(partnersEventFileUrl, data).then(response => {
        return response;
    });
}